<div class="custella-modal d-flex flex-column">
  <div class="custella-modal-header">
    <div class="custella-modal-header-text" id="title_MaintenanceJobs">{{ title }}</div>
    <i class="pi pi-times pt-1" id="btn_MaintenanceJobsClose" [pTooltip]="translate?.general.buttons.close.singular"
      tooltipPosition="left" (click)="modalRef.hide()"></i>
  </div>

  <div class="custella-modal-body mb-3 pt-0">
    <div class="d-flex align-items-center justify-content-end my-3">
      <div class="custella-dashboard-top-right d-flex">
        <button type="button" class="btn-list-icon ms-2" id="btn_MaintenanceJobsRefresh"
          [pTooltip]="translate?.general.buttons.refresh.singular" tooltipPosition="bottom" (click)="refresh()">
          <i class="fa-regular fa-arrows-rotate"></i>
        </button>

        <button type="button" class="btn-list-icon ms-2" id="btn_MaintenanceJobsFilter"
          [pTooltip]="translate?.general.buttons.filter.singular" tooltipPosition="bottom" (click)="toggleFilter()">
          <i class="fa-regular fa-filter-list"></i>
        </button>

        <div class="p-inputgroup search ms-2">
          <span class="p-input-icon-right">
            <input type="text" class="w-100" [(ngModel)]="searchValue" pInputText autocomplete="off"
              [placeholder]="translate?.general.buttons.search.singular" id="input_MaintenanceJobsSearchField"
              (keyup)="onSearchCheck()" (keydown.enter)="onSearch()" />
            <i *ngIf="searchValueData" class="p-autocomplete-clear-icon pi pi-times" id="btn_MaintenanceJobsSearchClear"
              (click)="onClear()"></i>
          </span>
          <button type="button" pButton icon="fa-regular fa-magnifying-glass" (click)="onSearch()"
            id="btn_MaintenanceJobsSearch"></button>
        </div>
      </div>
    </div>

    <div class="position-relative fw-normal d-flex" style="height: 60vh;">
      <div class="table-space ag-grid-table-full" [ngClass]="{ 'ag-grid-table': filterActive }">
        <ag-grid-angular #agGrid [headerHeight]="33" [rowHeight]="27" style="height: 100%;" class="ag-theme-balham"
          [columnDefs]="columnDefs" [gridOptions]="gridOptions" [defaultColDef]="defaultColDef" [cacheOverflowSize]="2"
          [maxConcurrentDatasourceRequests]="-1" [components]="frameworkComponents" (cellClicked)="view($event)"
          (gridReady)="onGridReady($event)" [overlayNoRowsTemplate]="overlayNoRowsTemplate"
          [getContextMenuItems]="getContextMenuItems">
        </ag-grid-angular>
        <div class="col-12">
          <p class="ag-record-row-summary-panel padds text-end" id="label_MaintenanceJobsTableRec">
            {{ totalRecord }}&nbsp;{{ translate?.general.messages.records }}
          </p>
        </div>
      </div>

      <!-- Filter -->
      <div class="custella-form-container-content-pane layout-filter"
        [ngClass]="{ 'layout-filter-active': filterActive }" *ngIf="filterActive">
        <div class="custella-form-container-content-pane-title">
          <span class="text-14 font-medium" id="label_MaintenanceJobsFilter">{{translate?.general.messages.filterBy}}</span>
          <i class="fa-regular fa-arrow-right-from-line" [pTooltip]="translate?.general.buttons.closeFilter.singular"
            tooltipPosition="left" (click)="toggleFilter()" id="btn_MaintenanceJobsClose"></i>
        </div>
        <div class="custella-content" #FilterContainer>
          <div class="custella-content-input col-12">
            <span class="custella-content-input-title" id="label_MaintenanceJobsTimeRange">Time range</span>
            <p-dropdown
              [options]="timeRangeOptions"
              optionLabel="label"
              optionValue="value"
              [ngModel]="filteredOptions.dateFilter"
              (ngModelChange)="onTimeRangeChange($event)"
              [placeholder]="translate?.general.messages.none">
            </p-dropdown>
            <span class="text-10 color-muted" *ngIf="displayDateRange && filteredOptions.dateFilter !== 'CUSTOM'">
              {{ displayDateRange }}
            </span>
          </div>
          <div class="custella-content-input col-12" *ngIf="filteredOptions.dateFilter === 'CUSTOM'">
            <span class="custella-content-input-title" id="label_MaintenanceJobsCustomDateRange">Custom date range</span>
            <p-calendar
              [ngModel]="customDateRange"
              (ngModelChange)="onCustomDateRangeChange($event)"
              selectionMode="range"
              dateFormat="dd/mm/yy"
              [readonlyInput]="true"
              placeholder="Select date range"
              appendTo="body">
            </p-calendar>
            <div class="p-error text-10" *ngIf="isCustomDateRangeRequired">
              Start and end date are required
            </div>
          </div>
          <div class="custella-content-input col-12">
            <span class="custella-content-input-title" id="label_MaintenanceJobsAssetTypes">{{translate?.asset.label.singular}}
              {{translate?.asset.fields.type.singular}}</span>
            <p-dropdown
              [placeholder]="translate?.general.messages.none"
              [options]="equipmentTypeOptions"
              optionLabel="label"
              optionValue="id"
              [filter]="true"
              [ngModel]="filteredOptions.assetTypeIds"
              (ngModelChange)="onFilterChange('assetTypeIds', $event)"
              [showClear]="true">
            </p-dropdown>
          </div>
          <div class="custella-content-input col-12">
            <span class="custella-content-input-title"
              id="label_MaintenanceJobsGroups">{{translate?.setup.users.groups.label.singular}}</span>
              <p-dropdown
                [placeholder]="translate?.general.messages.none"
                [options]="groupOptions"
                optionLabel="name"
                optionValue="id"
                [filter]="true"
                [ngModel]="filteredOptions.userGroupIds"
                (ngModelChange)="onFilterChange('userGroupIds', $event)"
                [showClear]="true">
              </p-dropdown>
          </div>
          <div class="custella-content-input col-12">
            <span class="custella-content-input-title"
              id="label_MaintenanceJobsServiceZone">{{translate?.setup.serviceZone.label.singular}}</span>
              <p-dropdown
                [placeholder]="translate?.general.messages.none"
                [options]="serviceZoneOptions"
                optionLabel="name"
                optionValue="id"
                [filter]="true"
                [ngModel]="filteredOptions.assetServiceZoneIds"
                (ngModelChange)="onFilterChange('assetServiceZoneIds', $event)"
                [showClear]="true">
              </p-dropdown>
          </div>
          <div>
            <span href="#" class="clear" (click)="clearAll()"
              id="subtitle_MaintenanceJobsClear">{{translate?.general.buttons.clearAll.singular }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>